export const formatTime = (seconds) => {
  if (isNaN(seconds) || seconds === null) return '00:00';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) {
    return `${h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
  }
  return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
};

export const parseTimeInput = (value) => {
  if (!value) return 0;
  if (typeof value === 'number') return value;
  if (!value.toString().includes(':')) return parseFloat(value) || 0;
  
  const parts = value.split(':');
  if (parts.length === 2) {
    const mins = parseInt(parts[0]) || 0;
    const secs = parseInt(parts[1]) || 0;
    return mins * 60 + secs;
  } else if (parts.length === 3) {
    const hrs = parseInt(parts[0]) || 0;
    const mins = parseInt(parts[1]) || 0;
    const secs = parseInt(parts[2]) || 0;
    return hrs * 3600 + mins * 60 + secs;
  }
  return parseFloat(value) || 0;
};
